<template>
  <div
    v-if="property?.property_manager"
    class="tw-mx-auto tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-3 tw-border tw-p-6 tw-text-center md:tw-p-8"
    style="border-radius: var(--rounded); border-color: var(--c-border)"
  >
    <!-- Property Manager Photo -->
    <div
      class="tw-mb-2"
      v-if="
        property.property_manager.image &&
        property.property_manager.image !== 'https://cdn.lifesycle.co.uk/avatars/unknown.jpg'
      "
    >
      <div
        class="tw-h-20 tw-w-20 tw-overflow-hidden tw-rounded-full tw-border-4 tw-shadow-md"
        style="border-color: var(--c-border)"
      >
        <library-image
          :src="property.property_manager.image"
          :alt="`${property.property_manager.name} ${property.property_manager.surname}`"
          :title="`${property.property_manager.name} ${property.property_manager.surname}`"
          image-class="tw-h-full tw-w-full tw-object-cover"
          :design-width="80"
          :design-height="80"
        />
      </div>
    </div>

    <!-- Property Manager Name -->
    <div class="tw-mb-1">
      <h5 class="tw-font-semibold tw-text-gray-900">
        {{ property.property_manager.name }} {{ property.property_manager.surname }}
      </h5>
      <p class="tw-text-sm tw-text-gray-600">
        {{ property.property_manager.job_title || 'Property Manager' }}
      </p>
    </div>

    <!-- Property Manager Email -->
    <div class="tw-mb-2 tw-flex tw-flex-col tw-items-center tw-gap-2">
      <a
        :href="`mailto:${property.property_manager.email}`"
        class="tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-blue-600 tw-transition-colors hover:tw-text-blue-800"
      >
        <svg class="tw-h-4 tw-w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 8l7.89 7.89a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
        {{ property.property_manager.email }}
      </a>
      <a
        :href="`tel:${property.property_manager.phone}`"
        class="tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-blue-600 tw-transition-colors hover:tw-text-blue-800"
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.34 10.2533C12.52 10.2533 11.7267 10.12 10.9867 9.88C10.8707 9.8407 10.7461 9.83487 10.627 9.86317C10.5079 9.89147 10.3992 9.95275 10.3133 10.04L9.26667 11.3533C7.38 10.4533 5.61333 8.75333 4.67333 6.8L5.97333 5.69333C6.15333 5.50667 6.20667 5.24667 6.13333 5.01333C5.88667 4.27333 5.76 3.48 5.76 2.66C5.76 2.3 5.46 2 5.1 2H2.79333C2.43333 2 2 2.16 2 2.66C2 8.85333 7.15333 14 13.34 14C13.8133 14 14 13.58 14 13.2133V10.9133C14 10.5533 13.7 10.2533 13.34 10.2533Z"
            fill="blue"
          ></path>
        </svg>
        {{ property.property_manager.phone }}
      </a>
    </div>

    <!-- Contact Button -->
    <a
      :href="
        property?.property_manager?.phone
          ? `tel:${property.property_manager.phone}`
          : `mailto:${property.property_manager.email}`
      "
      style="border-color: var(--c-border)"
      class="n-primary tw-max-w-xs tw-border tw-px-4 tw-py-3 tw-text-center"
    >
      Contact Manager
    </a>
  </div>
</template>

<script lang="ts">
import { mapActions } from 'pinia';
import { ROUTES } from '~/constants/ui.constants';
import { usePropertiesStore } from '~/units/properties/stores';
import type { Component } from '~/types';
import { ComponentMixin } from '~/mixins/component.mixin';
import { PropertyMixin } from '~/units/properties/mixins/property.mixin';
import { FullScreenPopupMixin } from '~/units/core/mixins/fullScreenPopupMixin';
import { getImagesByCount } from '~/units/properties/store';

export default defineNuxtComponent({
  name: 'ManageCard',

  mixins: [ComponentMixin, PropertyMixin, FullScreenPopupMixin],

  data() {
    return {
      form: null,
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },

  created() {
    this.form = this.parseFormV2(this.vars.cardForm);
  },

  computed: {
    variant() {
      return useVariant(this.component);
    },

    buttons() {
      return this.groupedVariables.buttons;
    },

    descriptions() {
      return this.groupedVariables.descriptions;
    },
  },
});
</script>
